
(function () {
  "use strict";

  function init(root) {
    if (root.dataset.ready === "1") return;
    root.dataset.ready = "1";

    const $ = s => root.querySelector(s);
    const manifestUrl = root.dataset.manifestUrl;
    const stage = $(".satfb__stage");
    const book = $(".satfb__book");
    const flipEl = $(".satfb__flip");
    const loading = $(".satfb__loading");
    const bar = $(".satfb__progress");
    const thumbs = $(".satfb__thumbs");
    const thumbList = $(".satfb__thumb-list");
    const pageInput = $(".satfb__page");
    const totalEl = $(".satfb__total");
    const zoomEl = $(".satfb__zoom");
    const toast = $(".satfb__toast");

    let manifest, flip, current = 0, zoom = 1;
    let panX = 0, panY = 0, dragging = false, sx = 0, sy = 0, ox = 0, oy = 0;
    let wheelLock = false, resizeTimer;

    function msg(t) {
      toast.textContent = t;
      toast.classList.add("show");
      setTimeout(() => toast.classList.remove("show"), 1600);
    }

    function pageUrl(i) { return manifest.pages[i]; }

    function makePage(i) {
      const p = document.createElement("div");
      p.className = "satfb__page";
      p.dataset.index = i;
      const img = document.createElement("img");
      img.alt = `${manifest.title || "Catalogue"} page ${i + 1}`;
      img.loading = i < 3 ? "eager" : "lazy";
      img.decoding = "async";
      img.dataset.src = pageUrl(i);
      p.appendChild(img);
      return p;
    }

    function loadPage(i) {
      if (i < 0 || i >= manifest.pages.length) return;
      const img = root.querySelector(`.satfb__page[data-index="${i}"] img`);
      if (img && !img.src) img.src = img.dataset.src;
    }

    function preload(i) {
      for (let n = -2; n <= 3; n++) loadPage(i + n);
    }

    function buildThumbs() {
      if (!thumbList) return;
      const frag = document.createDocumentFragment();
      manifest.pages.forEach((src, i) => {
        const b = document.createElement("button");
        b.className = "satfb__thumb";
        b.type = "button";
        b.dataset.index = i;
        b.innerHTML = `<img src="${src}" loading="lazy"><span>${i === 0 ? "Cover" : i === manifest.pages.length - 1 ? "Back cover" : i + 1}</span>`;
        b.onclick = () => go(i);
        frag.appendChild(b);
      });
      thumbList.replaceChildren(frag);
    }

    function update() {
      pageInput.value = current + 1;
      totalEl.textContent = `/ ${manifest.pages.length}`;
      zoomEl.textContent = `${Math.round(zoom * 100)}%`;
      root.querySelectorAll(".satfb__thumb").forEach(x =>
        x.classList.toggle("active", Number(x.dataset.index) === current)
      );
    }

    function go(i) {
      i = Math.max(0, Math.min(manifest.pages.length - 1, Number(i)));
      if (flip) flip.turnToPage(i);
      current = i;
      preload(i);
      resetPan();
      update();
      history.replaceState(null, "", location.pathname + location.search + "#page=" + (i + 1));
    }

    function size() {
    const ratio = 210 / 297;

    const w = stage.clientWidth;
    const h = stage.clientHeight;

    let pageWidth;
    let pageHeight;

    if (window.innerWidth <= 768) {

        /*
         * MOBILE
         * Keep TWO A4 pages side-by-side.
         */

        const horizontalGap = 8;

        const maxSpreadWidth = w * 0.96;
        const maxSpreadHeight = h * 0.88;

        pageWidth = Math.min(
            (maxSpreadWidth - horizontalGap) / 2,
            maxSpreadHeight * ratio
        );

        pageHeight = pageWidth / ratio;

    } else {

        /*
         * DESKTOP
         */

        const maxSpreadWidth = w * 0.86;
        const maxSpreadHeight = h * 0.90;

        pageWidth = Math.min(
            maxSpreadWidth / 2,
            maxSpreadHeight * ratio
        );

        pageHeight = pageWidth / ratio;
    }

    return {
        width: Math.max(140, Math.floor(pageWidth)),
        height: Math.max(198, Math.floor(pageHeight))
    };
}

    function createFlip() {
      const s = size();
      flipEl.replaceChildren();
      flip = new St.PageFlip(flipEl, {
        width: s.width, height: s.height, size: "fixed",
        minWidth: 260, maxWidth: 1000, minHeight: 368, maxHeight: 1400,
        showCover: true, usePortrait: false,
        autoSize: false, flippingTime: 800,
        drawShadow: true, maxShadowOpacity: .38,
        showPageCorners: true, swipeDistance: 25,
        useMouseEvents: true, mobileScrollSupport: false
      });
      flip.loadFromHTML(manifest.pages.map((_, i) => makePage(i)));
      flip.on("flip", e => {
        current = e.data;
        preload(current);
        resetPan();
        update();
      });
      preload(current);
      update();
    }

    function applyPan() {
      book.style.transform = `translate3d(${panX}px,${panY}px,0) scale(${zoom})`;
      book.classList.toggle("zoomed", zoom > 1);
    }

    function resetPan() {
      panX = panY = 0;
      applyPan();
    }

    async function toggleLandscape() {
      try {
          // Enter fullscreen first because some browsers
          // only allow orientation locking in fullscreen.
          if (!document.fullscreenElement) {
              await root.requestFullscreen();
          }

          // Ask the browser to switch to landscape.
          if (
              screen.orientation &&
              screen.orientation.lock
          ) {
              await screen.orientation.lock("landscape");
          } else {
              msg("Please rotate your device to landscape");
          }

          // Recalculate the flipbook dimensions.
          setTimeout(() => {
              rebuild();
          }, 300);

      } catch (error) {
          console.log("Landscape mode:", error);

          msg("Please rotate your device to landscape");

          setTimeout(() => {
              rebuild();
          }, 300);
      }
    }

    function setZoom(z) {
      zoom = Math.max(1, Math.min(2.5, z));
      resetPan();
      update();
    }

    function rebuild() {
      const p = current;
      createFlip();
      setTimeout(() => go(p), 40);
    }

    function share() {
      const u = new URL(location.href);
      u.hash = "page=" + (current + 1);
      const dialog = $(".satfb__share");
      $(".satfb__share-url").value = u.toString();
      if (dialog.showModal) dialog.showModal(); else dialog.classList.add("open");
    }

    async function copyShare() {
      const input = $(".satfb__share-url");
      try { await navigator.clipboard.writeText(input.value); }
      catch { input.select(); document.execCommand("copy"); }
      msg("Page link copied");
    }

    async function nativeShare() {
      const url = $(".satfb__share-url").value;
      if (navigator.share) {
        try { await navigator.share({ title: manifest.title || "Catalogue", url }); } catch {}
      } else copyShare();
    }

    function bind() {
      $(".satfb__thumb-toggle")?.addEventListener("click", () => thumbs?.classList.toggle("open"));
      $(".satfb__thumb-close")?.addEventListener("click", () => thumbs?.classList.remove("open"));
      $(".satfb__prev").onclick = () => flip.flipPrev();
      $(".satfb__next").onclick = () => flip.flipNext();
      $(".satfb__first").onclick = () => go(0);
      $(".satfb__last").onclick = () => go(manifest.pages.length - 1);
      pageInput.onkeydown = e => { if (e.key === "Enter") go(Number(pageInput.value) - 1); };
      $(".satfb__minus")?.addEventListener("click", () => setZoom(zoom - .25));
      $(".satfb__plus")?.addEventListener("click", () => setZoom(zoom + .25));
      $(".satfb__single")?.addEventListener("click", () => { root.dataset.view = "single"; rebuild(); });
      $(".satfb__double")?.addEventListener("click", () => { root.dataset.view = "double"; rebuild(); });
      $(".satfb__share-btn")?.addEventListener("click", share);
      $(".satfb__share-copy")?.addEventListener("click", copyShare);
      $(".satfb__share-native")?.addEventListener("click", nativeShare);
      $(".satfb__share-close")?.addEventListener("click", () => $(".satfb__share").close?.());
      $(".satfb__fullscreen")?.addEventListener("click", () =>
        document.fullscreenElement ? document.exitFullscreen() : root.requestFullscreen()
      );
      $(".satfb__orientation")?.addEventListener(
          "click",
          toggleLandscape
      );
      $(".satfb__download")?.addEventListener("click", () => {
        if (!root.dataset.pdfUrl) return msg("PDF download is not configured");
        window.open(root.dataset.pdfUrl, "_blank", "noopener");
      });
      $(".satfb__hide")?.addEventListener("click", () => root.classList.add("toolbar-hidden"));
      $(".satfb__show")?.addEventListener("click", () => root.classList.remove("toolbar-hidden"));

      stage.addEventListener("wheel", e => {
        if (zoom > 1 || wheelLock) return;
        e.preventDefault(); wheelLock = true;
        e.deltaY > 0 ? flip.flipNext() : flip.flipPrev();
        setTimeout(() => wheelLock = false, 650);
      }, { passive: false });

      // IMPORTANT: panning starts ONLY when the actual page is clicked.
      stage.addEventListener("pointerdown", e => {
        if (zoom <= 1 || !e.target.closest(".satfb__page, .satfb__page img")) return;
        dragging = true; sx = e.clientX; sy = e.clientY; ox = panX; oy = panY;
        stage.setPointerCapture?.(e.pointerId);
        e.preventDefault();
      });
      stage.addEventListener("pointermove", e => {
        if (!dragging) return;
        panX = ox + e.clientX - sx;
        panY = oy + e.clientY - sy;
        applyPan();
      });
      stage.addEventListener("pointerup", e => {
        dragging = false;
        stage.releasePointerCapture?.(e.pointerId);
      });
      stage.addEventListener("pointercancel", () => dragging = false);

      stage.addEventListener("dblclick", e => {
        if (e.target.closest(".satfb__page, .satfb__page img"))
          setZoom(zoom === 1 ? 1.5 : 1);
      });

      document.addEventListener("keydown", e => {
        if (["INPUT","TEXTAREA"].includes(document.activeElement.tagName)) return;
        if (e.key === "ArrowRight") flip.flipNext();
        if (e.key === "ArrowLeft") flip.flipPrev();
        if (e.key === "Home") go(0);
        if (e.key === "End") go(manifest.pages.length - 1);
        if (e.key === "+") setZoom(zoom + .25);
        if (e.key === "-") setZoom(zoom - .25);
        if (e.key.toLowerCase() === "t") thumbs?.classList.toggle("open");
        if (e.key.toLowerCase() === "f") document.fullscreenElement ? document.exitFullscreen() : root.requestFullscreen();
      });

      addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(rebuild, 250);
      });
    }

    async function init() {
      try {
        bar.style.width = "20%";
        const r = await fetch(manifestUrl, { cache: "force-cache" });
        if (!r.ok) throw new Error("Could not load manifest");
        manifest = await r.json();
        bar.style.width = "45%";
        buildThumbs();
        createFlip();
        bind();

        const match = location.hash.match(/page=(\d+)/);
        if (match) setTimeout(() => go(Number(match[1]) - 1), 80);

        bar.style.width = "100%";
        setTimeout(() => loading.classList.add("hidden"), 250);
      } catch (e) {
        loading.querySelector(".satfb__loading-text").textContent = e.message;
      }
    }

    init();
  }

  document.querySelectorAll(".sat-flipbook").forEach(init);
})();
